import type { LayerState, SerieLayer } from '@/api/generated/schemas';
import { SerieTransportType } from '@/api/generated/schemas';

/*
 * Backend serializuje enumy do JSON jako string (název hodnoty). Tyto mapy převádějí hodnoty na stabilní textové klíče
 * používané v i18n a stylech (a zpět pro request).
 */

export type SerieStateKey = 'locked' | 'draft' | 'approved' | 'published' | 'changes';
const STATE_KEY_BY_VALUE: Record<LayerState, SerieStateKey> = {
  Locked: 'locked',
  Draft: 'draft',
  Approved: 'approved',
  Published: 'published',
  Changes: 'changes',
};

export function toSerieStateKey(state: LayerState): SerieStateKey {
  return STATE_KEY_BY_VALUE[state];
}

export type SerieLayerKey = 'terms' | 'operation' | 'productCost' | 'calculation' | 'marketing';
const LAYER_KEY_BY_VALUE: Record<SerieLayer, SerieLayerKey> = {
  Terms: 'terms',
  OperationScheme: 'operation',
  ProductCostScheme: 'productCost',
  Calculation: 'calculation',
  Marketing: 'marketing',
};

export function toSerieLayerKey(layer: SerieLayer): SerieLayerKey {
  return LAYER_KEY_BY_VALUE[layer];
}

export type SerieTransportKey = 'flight' | 'bus' | 'combined';
const TRANSPORT_KEY_BY_VALUE: Record<SerieTransportType, SerieTransportKey> = {
  Flight: 'flight',
  Bus: 'bus',
  Combined: 'combined',
};

export function toSerieTransportKey(type: SerieTransportType): SerieTransportKey {
  return TRANSPORT_KEY_BY_VALUE[type];
}

const TRANSPORT_VALUE_BY_KEY: Record<SerieTransportKey, SerieTransportType> = {
  flight: SerieTransportType.Flight,
  bus: SerieTransportType.Bus,
  combined: SerieTransportType.Combined,
};

export function toSerieTransportApi(key: SerieTransportKey): SerieTransportType {
  return TRANSPORT_VALUE_BY_KEY[key];
}

/**
 * Klíče tabů v pořadí vrstev. `basics` (Základní údaje a termíny) odpovídá vrstvě „Termíny“ (index 0);
 * ostatní indexy odpovídají vrstvám Operation / Product cost / Calculation / Marketing.
 */
export const SERIE_TAB_KEYS = [
  'basics',
  'operation',
  'productCost',
  'calculation',
  'marketing',
] as const;

export type SerieTabKey = (typeof SERIE_TAB_KEYS)[number];
